(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.UCQuickAddAutoClose) return;
    window.UCQuickAddAutoClose = true;

    var timers = {};

    function isMobile() {
      return window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
    }

    // Open / close the mobile quick-add panel
    document.addEventListener('change', function (e) {
      var toggle = e.target.closest('.uc-quickadd-toggle');
      if (!toggle) return;

      var id = toggle.id;
      var panel = toggle.nextElementSibling && toggle.nextElementSibling.classList.contains('uc-quickadd-panel')
        ? toggle.nextElementSibling
        : null;

      if (panel) {
        panel.dataset.ucInteracted = 'false';
      }

      if (timers[id]) {
        clearTimeout(timers[id]);
        delete timers[id];
      }

      if (toggle.checked && isMobile()) {
        timers[id] = setTimeout(function () {
          var input = document.getElementById(id);
          if (!input) return;

          var p = input.nextElementSibling && input.nextElementSibling.classList.contains('uc-quickadd-panel')
            ? input.nextElementSibling
            : null;

          if (input.checked) {
            if (p && p.dataset.ucInteracted === 'true') return;
            input.checked = false;
            var evt = new Event('change', { bubbles: true });
            input.dispatchEvent(evt);
          }
        }, 5000);
      }
    });

    // Track interaction with quick-add buttons & close
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.uc-quickadd-btn');
      if (btn) {
        var panel = btn.closest('.uc-quickadd-panel');
        if (panel) {
          panel.dataset.ucInteracted = 'true';
        }
        return;
      }

      var close = e.target.closest('.uc-quickadd-close');
      if (close) {
        var forId = close.getAttribute('for');
        if (forId && timers[forId]) {
          clearTimeout(timers[forId]);
          delete timers[forId];
        }
      }
    });

    // Colour swatch tap: preview that colourway in place  swap the card image to that
    // product's first image, repoint the card's links, and update the colour line.
    // The <a href> stays as a no-JS / keyboard fallback.
    document.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-uc-swatch]');
      if (!sw) return;

      var card = sw.closest('.product-card');
      if (!card) return;

      e.preventDefault();

      var url = sw.getAttribute('data-uc-url');
      var img = sw.getAttribute('data-uc-img');
      var srcset = sw.getAttribute('data-uc-srcset');

      var primary = card.querySelector('.product-card__image--primary');
      var secondary = card.querySelector('.product-card__image--secondary');

      if (primary && img) {
        if (srcset) primary.setAttribute('srcset', srcset);
        primary.setAttribute('src', img);
      }
      if (secondary && img) {
        if (srcset) secondary.setAttribute('srcset', srcset);
        secondary.setAttribute('src', img);
      }

      if (url) {
        var media = card.querySelector('.product-card__media');
        if (media) media.setAttribute('href', url);
        var title = card.querySelector('.product-title');
        if (title) title.setAttribute('href', url);
      }

      var colorName = sw.getAttribute('data-uc-color');
      var colorLine = card.querySelector('[data-uc-color-line]');
      if (colorLine && colorName) {
        colorLine.textContent = colorName;
        if (url) colorLine.setAttribute('href', url);
      }

      var swatches = card.querySelectorAll('.uc-swatch');
      for (var i = 0; i < swatches.length; i++) {
        swatches[i].classList.remove('is-selected');
      }
      sw.classList.add('is-selected');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
